<template>
  <div>
    <v-sheet height="100%" color="grey darken-3" tile
      ><v-container>
        <v-row align="center" justify="center">
          <v-col md="4" lg="4" sm="12">
            <v-card
              class="mx-auto pl-5 pt-5 pr-5 pb-5"
              max-width="300"
              max-height="800"
              color="white"
            >
              <v-img src="@/assets/k.jpg" height="200px"></v-img>
              <p class="text-left pl-5 pt-5 pr-5 pb-5">
                I WANT TO
               
                <b> WORK</b>
              </p>
              <div class="text-left pt-3 pb-3 pl-3 pr-">
                <v-btn class="mx-2" fab dark small color="green accent-4">
                  <v-icon dark> mdi-arrow-right-bold </v-icon>
                </v-btn>
              </div>
            </v-card>
          </v-col>
          <v-col md="4" lg="4" sm="12">
            <v-card
              class="mx-auto pl-5 pt-5 pr-5 pb-5"
              max-width="300"
              max-height="800"
              color="white"
            >
              <v-img src="@/assets/l.jpg" height="200px"></v-img>
              <p class="text-left pl-5 pt-5 pr-5 pb-5">
                I WANT TO
             
                <b> STUDY</b>
              </p>
              <div class="text-left pt-3 pb-3 pl-3 pr-">
                <v-btn class="mx-2" fab dark small color="green accent-4">
                  <v-icon dark> mdi-arrow-right-bold </v-icon>
                </v-btn>
              </div>
            </v-card>
          </v-col>
          <v-col md="4" lg="4" sm="12">
            <v-card
              class="mx-auto pl-5 pt-5 pr-5 pb-5"
              max-width="300"
              max-height="800"
              color="white"
            >
              <v-img src="@/assets/br.png" height="200px"></v-img>
              <p class="text-left pl-5 pt-5 pr-5 pb-5">
                I WANT TO
              
                <b> VISIT</b>
              </p>
              <div class="text-left pt-3 pb-3 pl-3 pr-">
                <v-btn class="mx-2" fab dark small color="green accent-4">
                  <v-icon dark> mdi-arrow-right-bold </v-icon>
                </v-btn>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="pt-5">
          <v-card class="mx-auto cardRow" color="black" outlined>
            <div class="text-left">
              <h3>Not Sure What you’re <br />looking for?</h3>
              <h4>Knowing your CRS score can help you decide</h4>
            </div>
            <div class="text-left pl-3 pb-3 pt-5">
              <v-btn rounded color="green accent-4" dark>
                <b>check if you're eligible</b></v-btn
              >
            </div>
          </v-card></v-row
        >
      </v-container>
    </v-sheet>
  </div>
</template>
<script>
export default {
  data() {
    return {
      colors: ["secondary", "secondary"],
      cycle: false,
    };
  },
};
</script>
<style scoped>
h4 {
  text-align: left;
  color: rgb(254, 254, 254);
  font-size: 25px;
}
h1 {
  text-align: center;
  font-size: 25px;
}
h2 {
  color: black;
  text-align: center;
}
p {
  color: black;
  font-size: 23px;
  padding-top: 10px;
}
h3 {
  color: rgb(255, 255, 255);
  text-align: left;
  font-size: 40px;
}
.inner-img {
  transition: 0.3s;
}

.inner-img:hover {
  transform: scale(0.9);
}
.cardRow {
  padding-left: 80px;
  padding-right: 80px;
  padding-top: 80px;
  padding-bottom: 80px;
}

/* Other styling elements, that are not necessary for the example */
</style>